import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { NewProvisionComponent } from '../../create-new/new-provision/new-provision.component';


@Injectable({
  providedIn: 'root'
})
export class PendingProvisionChangesGuard  {
  canDeactivate(
    component: NewProvisionComponent,
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {

    if (!component.okToLeaveIntakeForm) {
      return confirm('WARNING: You have unsaved changes. Press Cancel to continue working or OK to leave this page without saving changes.');
    } else {
      return true;
    }

  }
}
